import React, { FC } from 'react';
import { useNavigate } from 'react-router-dom';

import { PlusIcon } from '../../../assets/icons/index';
import noCompaniesImg from '../../../assets/images/no-companies.png';
import { AppFormattedMessage } from '../../../components/app-formatted-message/index';
import Button from '../../../components/button/index';
import { AnalyticHooks, Company } from '../../../hooks/index';
import { PossibleAction } from '../../../types/google-analytics-types.types';

const EmptyCompanyCard: FC = () => {
  const navigate = useNavigate();
  const companyCreationTracker = AnalyticHooks.useClick(PossibleAction.ADD_COMPANY);
  const { create } = Company.useCreate();

  return (
    <div className="flex w-full items-center justify-center">
      <div className="radial-gradient-border relative flex flex-col gap-6 rounded-2xl px-6 py-8 lg:min-w-[393px]">
        <div className="flex items-center gap-3">
          <div className="size-[96px] object-cover">
            <img alt="" src={noCompaniesImg} />
          </div>
          <div className="flex flex-col gap-[2px]">
            <span className="text-xl font-semibold text-gray-700">
              <AppFormattedMessage id="ADD_YOUR_COMPANY" />
            </span>
            <span className="text-xs font-[450] text-gray-600">
              <AppFormattedMessage id="MANAGE_CAP_TABLE_EFFORTLESSLY" />
            </span>
          </div>
        </div>
        <div className="flex items-center justify-center">
          <Button
            className="w-fit gap-1 px-4 py-2"
            onClick={() =>
              create(undefined, {
                onSuccess: ({ id }) => {
                  companyCreationTracker();
                  navigate(`/company-setup/${id}`);
                },
              })
            }
          >
            <div>
              <PlusIcon />
            </div>
            <span>
              <AppFormattedMessage id="ADD_NEW_COMPANY" />
            </span>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default EmptyCompanyCard;
